export const parseOfferDescription = (offer) => {
    if (!offer) {
        return;
    }
    const desc = (offer === null || offer === void 0 ? void 0 : offer.description) || "";
    const regexParts = [
        /(?<=\w\s?)for [R₹]s?\s?\d+/,
        /(?<=\w+\s)get \d+ Free/,
        /(?<=\w+\s)get free/,
        /\d+\s?% discount/,
        /[R₹]s?\s?\d+/,
        /Flat [R₹]s?\s?\d+ off/,
        /\d+\s?% off/,
        /1 Free/,
        /(?<=\w+\s)free/, // Matches "free" preceded by a word and space
    ];
    const regex = new RegExp(regexParts.map((r) => r.source).join("|"), "gi");
    const match = desc.match(regex);
    if (match) {
        const heading2 = match[0];
        const index = desc.indexOf(heading2);
        const heading1 = desc.slice(0, index).trim();
        const heading3 = desc.slice(index + heading2.length).trim();
        return { heading1, heading2, heading3 };
    }
    if (offer.discountPercentage && offer.discountPercentage > 0) {
        return {
            heading1: "Enjoy",
            heading2: `${offer.discountPercentage}% OFF`,
            heading3: "",
        };
    }
    else if (offer.discountAmount && offer.discountAmount > 0) {
        return {
            heading1: "Save",
            heading2: `Flat ₹${offer.discountAmount} off`,
            heading3: "",
        };
    }
    else if (offer.offerPrice && offer.offerPrice > 0) {
        return {
            heading1: "Special Price",
            heading2: `₹${offer.offerPrice}`,
            heading3: "",
        };
    }
    return {
        heading1: "Get",
        heading2: "Great Offer",
        heading3: "",
    };
};
